import useEducationFeatures from './useEducationFeatures'

export default function useEducationFeature(feature) {
  const features = useEducationFeatures()

  return features ? features[feature] : null
}
